import React from "react";

/**
 * Verwaltet Object-URLs samt Freigabe: eine ersetzte URL wird freigegeben, beim Verlassen der
 * Ansicht alle verbliebenen. Ein Fehler darin ist ein Speicherleck, das niemand sieht — deshalb
 * liegt die Logik an einer Stelle statt in jedem Foto-Hook erneut.
 */
export function useObjectUrlCache(): {
  urls: Record<string, string>;
  register: (key: string, url: string) => void;
} {
  const [urls, setUrls] = React.useState<Record<string, string>>({});
  const previousRef = React.useRef<Record<string, string>>({});

  React.useEffect(() => {
    const previous = previousRef.current;
    for (const key of Object.keys(previous)) {
      if (previous[key] && previous[key] !== urls[key]) {
        try {
          URL.revokeObjectURL(previous[key]);
        } catch {
          // Bereits freigegebene URLs sind kein Fehlerfall.
        }
      }
    }
    previousRef.current = urls;
  }, [urls]);

  React.useEffect(() => {
    return () => {
      const previous = previousRef.current;
      for (const key of Object.keys(previous)) {
        try {
          URL.revokeObjectURL(previous[key]);
        } catch {
          // Bereits freigegebene URLs sind kein Fehlerfall.
        }
      }
    };
  }, []);

  const register = React.useCallback((key: string, url: string) => {
    setUrls((current) => ({ ...current, [key]: url }));
  }, []);

  return { urls, register };
}
